
export const treeMixin = {
	methods: {
			getStatusByInfo(info){
				let status = ''
				if(info.vehicleStatusTypeId=='1'){//空闲中
					status = 'run'
				}else if(info.vehicleStatusTypeId == '3'){//救援中
					status = 'follow'
				}else{//已暂停
					status = 'offline'
				} 
				return status
			},
			listToTree(data,firstPID,options) {
				options = options || {};
				var ID_KEY = options.idKey || 'id';
				var PARENT_KEY = options.parentKey || 'parent';
				var CHILDREN_KEY = options.childrenKey || 'children';
				var tree = [],
					childrenOf = {};
				var item, id, parentId;
				for(var i = 0, length = data.length; i < length; i++) {
					item = data[i]; 
					id = item[ID_KEY];
					parentId = item[PARENT_KEY] || 0;
					// every item may have children
					childrenOf[id] = childrenOf[id] || [];
					// init its children
					if(item.type != 2){
						item[CHILDREN_KEY] = childrenOf[id];
					}else{
						item.nodeClass = 'leaf'
						item.nodeClass = item.nodeClass + " " + this.getStatusByInfo(item);
					}
					if(parentId != firstPID) {
						
						// init its parent's children object
						childrenOf[parentId] = childrenOf[parentId] || [];
						// push it into its parent's children object
						childrenOf[parentId].push(item);
						
					} else {
						tree.push(item);
					}
				};
				
				return tree;
			}
			
  		}
	}






// WEBPACK FOOTER //
// ./src/components/common/Tree/mixin.js